import { action, observable, runInAction } from "mobx";
import { TableViewStore, BaseListViewStore, BaasicDropdownStore, BasicQueryCheckboxStore } from "core/stores";
import {
    FacilityOrderTemplateService,
    FacilityOrderService,
    FacilityInventoryCalculationService
} from "application/facility-order/services";
import { PickTicketHeaderService } from "application/pick-ticket/services";
import { FacilityInventoryCountHeaderService, FacilityInventoryCountDetailService } from "application/facility-inventory/services";
import _ from "lodash";
import React from "react";
import { toDate, isStjepan } from "core/utils";
import { GridMultilineBooleanCell } from "core/components";
import { resolveColumns } from "application/facility-order/util/resolveColumns";
import { uuid } from "core/utils";
import { ModalParams } from 'core/models';
import { ItemCategoryService } from 'application/product/services';
import { ScheduleService } from 'application/schedule/services';
import { LookupService } from "common/services";

class FacilityOrderTemplateListViewStore extends BaseListViewStore {
    @observable accessor oldDownloadUrl = null;
    @observable accessor downloadUrl = null;
    @observable accessor downloadInventoryUrl = null;
    @observable accessor counter = 0;
    @observable accessor isPickTicketCreated = false;
    @observable accessor isInventoryCreated = false;
    @observable accessor isPartBOnly = false;
    @observable accessor facilityOrder = null;
    @observable accessor allFacilityOrderTemplatesReviewed = false;
    @observable accessor noFacilityOrderTemplates = false;
    @observable accessor isImportEnabled = false;
    @observable accessor isPickTicketHeaderInProgres = false;
    @observable accessor isPickTicketHeaderCompleted = false;
    @observable accessor isSendOrder = false;

    constructor(rootStore) {
        const facilityOrderTemplateService = new FacilityOrderTemplateService(
            rootStore.application.baasic.apiClient
        );
        const facilityInventoryCalculationService = new FacilityInventoryCalculationService(
            rootStore.application.baasic.apiClient
        );
        const pickTicketHeaderService = new PickTicketHeaderService(rootStore.application.baasic.apiClient);
        const facilityInventoryCountHeaderService = new FacilityInventoryCountHeaderService(rootStore.application.baasic.apiClient);
        const facilityInventoryCountDetailService = new FacilityInventoryCountDetailService(rootStore.application.baasic.apiClient);
        const itemCategoryService = new ItemCategoryService(rootStore.application.baasic.apiClient);
        const scheduleService = new ScheduleService(rootStore.application.baasic.apiClient);
        const lookupService = new LookupService(rootStore.application.baasic.apiClient);

        const facilityOrderId = rootStore.routerStore.routerState.params.id;
        super(rootStore, {
            autoInit: true,
            name: "facility-order-template",
            routes: {
                edit: (patient) => {
                    var itemCategories = this.itemCategoryStore && _.map(this.itemCategoryStore.value, (i => { return i.id }));
                    if (itemCategories && itemCategories.length > 0) {
                        itemCategories = itemCategories.join(",");
                    }
                    this.rootStore.routerStore.goTo(
                        'master.app.main.facility-order.facility-order-template.edit', {
                        patientId: patient.patientId,
                        patientKey: patient.patientKey,
                        facilityOrderId: facilityOrderId,
                        inActive: this.inactiveQueryCheckboxStore.value,
                        nonCurrent: this.nonCurrentQueryCheckboxStore.value,
                        itemCategoryIds: itemCategories
                    }
                    );
                },
                createPatient: () => {
                    this.rootStore.routerStore.goTo('master.app.main.facility-order.facility-order-template.create-patient', {
                        facilityOrderId
                    });
                },
                openInventoryCalculationItem: () => {
                    let url = this.rootStore.routerStore.findRoute('master.app.main.facility-order.facility-inventory-calculation-items.list').pattern;
                    url = url.replace(":facilityOrderId", facilityOrderId);
                    window.open(`${url}`);
                },
                pickTicketDetails: () => {
                    window.open(`${this.rootStore.routerStore
                        .findRoute('master.app.main.facility-order.pick-ticket.list')
                        .pattern.replace(":facilityOrderId", facilityOrderId).replace(":pickTicketHeaderId", this.facilityOrder.pickTicketHeaderId)}
                        `);
                },
                insuranceCoverageStatusOverviewEmailEdit: () => {
                    window.open(`${this.rootStore.routerStore
                        .findRoute('master.app.main.facility-order.overview.edit-email')
                        .pattern.replace(":facilityOrderId", facilityOrderId)}
                        `);
                },
                documentationRequestEmailEdit: () => {
                    window.open(`${this.rootStore.routerStore
                        .findRoute('master.app.main.facility-order.documentation-request.edit-email')
                        .pattern.replace(":facilityOrderId", facilityOrderId)}
                        `);
                }
            },
            actions: () => {
                return {
                    find: async (params) => {
                        if (this.counter == 0) {
                            //set default rpp to 50
                            this.counter++;
                            this.queryUtility.filter.reset(500);
                            params = this.queryUtility.plainFilter;
                        }

                        var itemCategories = this.itemCategoryStore && _.map(this.itemCategoryStore.value, (i => { return i.id }));
                        if (itemCategories && itemCategories.length > 0) {
                            itemCategories = itemCategories.join(",");
                            params = _.extend(params, {
                                itemCategoryIds: itemCategories
                            });
                        }

                        params = _.extend(params, {
                            embed: "ItemCategory,Patient,ImportReference,SubCategory,FacilityOrderTemplateNotes,ImportDetailStatus,SubCategory.ItemCategory",
                            facilityOrderId: facilityOrderId,
                            inActive: params.inActive,
                            nonCurrent: params.nonCurrent
                        });

                        const response = await facilityOrderTemplateService.find(params);

                        runInAction(() => {
                            this.allFacilityOrderTemplatesReviewed = response.data.item
                                .every(item => item.isReviewed === true);
                            this.noFacilityOrderTemplates = response.data.item.length === 0;
                            this.isImportEnabled = response.data.item.some(i => i.isReviewed === true && (i.importDetailStatus.abrv === 'new' || i.importDetailStatus.abrv === 'failed'));
                        });

                        let responseGroup = _.groupBy(
                            response.data.item,
                            "patientId"
                        );

                        let items = [];
                        this.allEnteralReviewed = true;
                        _.each(responseGroup, (it) => {
                            let firstName;
                            let lastName;
                            let dateOfBirth;
                            let patientKey;
                            let patientId;
                            let btPatinentId;
                            let subCategory = [];
                            let templateId = [];
                            let ids = [];
                            let inactiveReason = [];
                            let nextRunDate = [];
                            let reference = [];
                            let facilityOrderTemplateNotes = [];
                            let isReviewed = [];
                            let importDetailStatus = [];
                            let missingProduct = [];
                            let notCurrent = [];
                            let errorMessage = [];
                            _.each(it, (i) => {
                                patientId = i.patient.id;
                                btPatinentId = i.patient.patientId;
                                patientKey = i.patient.patientKey;
                                firstName = i.patient.firstName;
                                lastName = i.patient.lastName;
                                dateOfBirth = i.patient && toDate(i.patient.dateOfBirth);
                                subCategory = _.concat(i.subCategory.name, subCategory);
                                // subCategory = (i.subCategory.abrv == "Formula" || i.subCategory.abrv == "G-Tube" ||
                                //     i.subCategory.abrv == "Oral-Supplements" || i.subCategory.abrv == "Enteral---Supplies" ||
                                //     i.subCategory.abrv == "Enteral---Pumps" || i.subCategory.abrv == "Respiratory---trachs-supply" ||
                                //     i.subCategory.abrv == "Trach-Tube") ? _.concat(i.itemCategory.name + " - " + i.subCategory.name, subCategory) : _.concat(i.subCategory.name, subCategory);
                                importDetailStatus = _.concat(i.importDetailStatus.name, importDetailStatus);
                                templateId = _.concat(i.templateId, templateId);
                                ids = _.concat(i.id, ids);
                                i.inactiveReason = i.inactiveReason == "DoNotSupply" ? "Do Not Supply" : i.inactiveReason;
                                inactiveReason = _.concat(
                                    i.inactiveReason,
                                    inactiveReason
                                );
                                nextRunDate = _.concat(
                                    toDate(i.nextRunDate),
                                    nextRunDate
                                );
                                const referenceName = i.importReference && i.importReference.abrv === 'not-found' ? `${i.importReference.abrv},${i.reference}`
                                    : i.importReference !== null ? i.importReference.name : "";

                                reference = _.concat(
                                    referenceName,
                                    reference
                                );

                                if (i.isReviewed === false && i.subCategory && i.subCategory.itemCategory && i.subCategory.itemCategory.abrv === "enteral") {
                                    this.allEnteralReviewed = false;
                                }
                                isReviewed.push(i.isReviewed);
                                facilityOrderTemplateNotes.push(i.facilityOrderTemplateNotes.filter(x => x.isActive));
                                missingProduct.push(i.missingProduct);
                                notCurrent.push(i.notCurrent);
                                errorMessage.push(i.errorMessage);
                            });
                            it.patientId = patientId;
                            it.btPatinentId = btPatinentId;
                            it.patientKey = patientKey;
                            it.firstName = firstName;
                            it.lastName = lastName;
                            it.dateOfBirth = dateOfBirth;
                            it.subCategory = subCategory;
                            it.templateId = templateId;
                            it.ids = ids;
                            it.inactiveReason = inactiveReason;
                            it.nextRunDate = nextRunDate;
                            it.reference = reference;
                            it.isReviewed = isReviewed;
                            it.facilityOrderTemplateNotes = facilityOrderTemplateNotes;
                            it.missingProduct = missingProduct;
                            it.importDetailStatus = importDetailStatus;
                            it.notCurrent = notCurrent;
                            it.errorMessage = errorMessage;
                            items.push({
                                patientId: it.patientId,
                                btPatinentId: it.btPatinentId,
                                patientKey: it.patientKey,
                                patientNumber: it.patientNumber,
                                firstName: it.firstName,
                                lastName: it.lastName,
                                dateOfBirth: it.dateOfBirth,
                                subCategory: it.subCategory,
                                templateId: it.templateId,
                                ids: it.ids,
                                inactiveReason: it.inactiveReason,
                                nextRunDate: it.nextRunDate,
                                reference: it.reference,
                                isReviewed: it.isReviewed,
                                facilityOrderTemplateNotes: it.facilityOrderTemplateNotes,
                                missingProduct: it.missingProduct,
                                importDetailStatus: it.importDetailStatus,
                                notCurrent: it.notCurrent,
                                errorMessage: it.errorMessage
                            });
                        });

                        const facilityInventoryCalculationResponse = await facilityInventoryCalculationService.getExisting(facilityOrderId);
                        if (facilityInventoryCalculationResponse != null) {
                            this.allEnteralReviewed = true;
                        }
                        const responseData = _.extend(response.data, {
                            item: _.map(items, (item) => {
                                return _.extend(item, {
                                    patientId: item.patientId,
                                    btPatinentId: item.btPatinentId,
                                    patientKey: item.patientKey,
                                    firstName: item.firstName,
                                    lastName: item.lastName,
                                    dateOfBirth: item.dateOfBirth,
                                    subCategory: item.subCategory,
                                    templateId: item.templateId,
                                    ids: item.ids,
                                    nextRunDate: item.nextRunDate,
                                    inactiveReason: item.inactiveReason,
                                    reference: item.reference,
                                    isReviewed: item.isReviewed.reverse(),
                                    facilityOrderTemplateNotes: item.facilityOrderTemplateNotes.reverse(),
                                    missingProduct: item.missingProduct.reverse(),
                                    importDetailStatus: item.importDetailStatus,
                                    isProcessing: item.templateId && item.templateId.every((t) => t === null),
                                    notCurrent: item.notCurrent.reverse(),
                                    errorMessage: item.errorMessage.reverse()
                                });
                            }),
                        });
                        this.onFindSuccess();

                        var responseImportDetailStatuses = await lookupService.getLookups('ImportDetailStatus');
                        var newStatus = responseImportDetailStatuses.importDetailStatus.find(x => x.abrv === "new");
                        let adjustedParams = {
                            ...params,
                            embed: "FacilityOrder,ItemCategory,Patient,ImportReference,SubCategory,SubCategory.ItemCategory",
                            facilityOrderId: facilityOrderId,
                            nonCurrent: true,
                            adjustNextRunDate: true,
                            importDetailStatusId: newStatus.id
                        };
                        const adjustDatesResponse = await facilityOrderTemplateService.find(adjustedParams);
                        if (adjustDatesResponse.data.item.length > 0) {
                            this.openAdjustNextRunDates();
                        }
                        return responseData;
                    },
                    createPickTicket: async (facilityOrderId) => {
                        const response = await pickTicketHeaderService.createPickTicket(facilityOrderId);

                        return response;
                    },
                    createFacilityInventoryCountHeader: async (facilityId, countDate) => {
                        const response = await facilityInventoryCountHeaderService.create({ facilityId: facilityId, countDate: countDate, isDone: false });
                        return response;
                    },
                    createFacilityInventoryCountDetails: async (facilityOrderId, facilityInventoryCountHeaderId) => {
                        const response = await facilityInventoryCountDetailService.createFacilityInventoryCountDetails({ facilityOrderId, facilityInventoryCountHeaderId });
                        return response;
                    },
                    convertFacilityInventoryCountDetails: async (facilityInventoryCountHeaderId) => {
                        const response = await facilityInventoryCountDetailService.convert(facilityInventoryCountHeaderId);
                        return response;
                    }
                };
            },
        });

        this.service = facilityOrderTemplateService;
        this.pickTicketHeaderService = pickTicketHeaderService;
        this.facilityInventoryCountDetailService = facilityInventoryCountDetailService;

        this.scheduleDateService = scheduleService;

        this.editFacilityOrderTemplateInactiveReasonModal = new ModalParams({});

        this.previewModal = new ModalParams({ onClose: null });
        this.patientAddModal = new ModalParams({});
        this.extraSuppliesAddModal = new ModalParams({});
        this.taskNotesModal = new ModalParams({});
        this.facilityInventoryCountEditModal = new ModalParams({ onClose: () => this.setTitle() });
        this.brightreeBaseUrl = rootStore.applicationStore.app.baasic.settings.brightreeBaseUrl;
        this.facilityOrderId = facilityOrderId;

        this.setTableStore(
            new TableViewStore(this.queryUtility, {
                columns: resolveColumns([
                    {
                        key: "btPatinentId",
                        title: "FACILITY_ORDER_TEMPLATE.LIST.COLUMNS.PATIENT_ID",
                        onClick: (item) => this.routes.edit(item),
                        width: 100
                    },
                    {
                        key: "lastName",
                        title: "FACILITY_ORDER_TEMPLATE.LIST.COLUMNS.LAST_NAME",
                        onClick: (item) => this.routes.edit(item),
                        width: 150
                    },
                    {
                        key: "firstName",
                        title: "FACILITY_ORDER_TEMPLATE.LIST.COLUMNS.FIRST_NAME",
                        onClick: (item) => this.routes.edit(item),
                        cell: (item) => this.renderFirstNameCell(item),
                        width: 150
                    },
                    {
                        key: "reference",
                        title: "FACILITY_ORDER_TEMPLATE.LIST.COLUMNS.REFERENCE",
                        cell: (item) => this.renderReferenceCell(item),
                    },
                    {
                        key: "inactiveReason",
                        title: "FACILITY_ORDER_TEMPLATE.LIST.COLUMNS.INACTIVE_REASON",
                        cell: (item) => this.renderInactiveReasonCell(item),
                    },
                    {
                        key: "subCategory",
                        title: "FACILITY_ORDER_TEMPLATE.LIST.COLUMNS.SUB_CATEGORY",
                        cell: (item) => this.renderSubCategoryCell(item),
                    },
                    {
                        key: "templateId",
                        title: "FACILITY_ORDER_TEMPLATE.LIST.COLUMNS.TEMPLATE",
                        cell: (item) => this.renderTemplateIdCell(item),
                        width: 100
                    },
                    {
                        key: "nextRunDate",
                        title: "FACILITY_ORDER_TEMPLATE.LIST.COLUMNS.NEXT_RUN_DATE",
                        cell: (item) => this.renderNextRunDateCell(item),
                        width: 120
                    },
                    {
                        key: "isReviewed",
                        title: "FACILITY_ORDER_TEMPLATE.LIST.COLUMNS.IS_REVIEWED",
                        cell: (item) => this.renderIsReviewedCell(item, this.routes.edit),
                        width: 100,
                        headerClassName: "center"
                    },
                    {
                        key: "importDetailStatus",
                        title: "FACILITY_ORDER_TEMPLATE.LIST.COLUMNS.IMPORT_DETAIL_STATUS",
                        cell: (item) => this.renderImportDetailStatusCell(item),
                        width: 110

                    },

                ]),
                actions: {
                    onEdit: (item) => this.openEditFacilityOrderTemplateInactiveReasonModal(item)
                }
            })
        );

        this.getFacilityOrder(facilityOrderId);
        this.setTitle();

        this.itemCategoryStore = new BaasicDropdownStore({
            multi: true, filterable: true
        }, {
            fetchFunc: async (term) => {
                const response = await itemCategoryService.find({
                    searchQuery: term,
                    rpp: 100
                });
                let filteredCategories = response.data.item.filter(i => i.abrv === "enteral" || i.abrv === "respiratory" || i.abrv === "urological"
                    || i.abrv === "ostomy" || i.abrv === "wound-care");
                return filteredCategories;
            },
        });

        this.inactiveQueryCheckboxStore = new BasicQueryCheckboxStore();
        this.queryUtility.filter.toggle('inActive');
        this.inactiveQueryCheckboxStore.setValue(true);
        this.nonCurrentQueryCheckboxStore = new BasicQueryCheckboxStore();
        this.queryUtility.filter.toggle('nonCurrent');
        this.nonCurrentQueryCheckboxStore.setValue(true);

        this.queryUtility.onResetFilter = () => {
            this.inactiveQueryCheckboxStore.reset(true);
            this.nonCurrentQueryCheckboxStore.reset(true);
            this.itemCategoryStore.setValue([]);
        }
    }

    @action.bound
    openEditFacilityOrderTemplateInactiveReasonModal(item) {
        this.setTitle();
        this.editFacilityOrderTemplateInactiveReasonModal.open({
            patientId: item.patientId,
            facilityOrderId: this.facilityOrderId,
            setFacilityOrderTemplateList: () => this.queryUtility.fetch(),
            checkAreTemplatesLinkedWithSpecificAreaOfCare: () => this.checkAreTemplatesLinkedWithSpecificAreaOfCare(item.patientId)
        });
    }

    @action.bound
    async checkAreTemplatesLinkedWithSpecificAreaOfCare(patientId) {
        var response = await this.service.isTemplateCategoryLinkedWithDoNotSupplyAreaOfCareOnFacility({ facilityOrderId: this.facilityOrderId, patientId: patientId });
        if (response.data) {
            this.rootStore.notificationStore.error("Some templates are linked with an Area of Care whose Coverage Type on the Facility is Don't Supply.");
        }
    }

    async getFacilityOrder(facilityOrderId) {
        const facilityOrderService = new FacilityOrderService(
            this.rootStore.application.baasic.apiClient
        );
        const response = await facilityOrderService.get(facilityOrderId, { embed: "ShippingStatus" });

        runInAction(() => {
            this.isInventoryCreated = response.data.facilityInventoryCountHeaderId !== null;
            this.isPickTicketCreated = response.data.pickTicketHeaderId !== null;
            this.facilityOrder = response.data;
            this.isSendOrder = this.facilityOrder.sendOrder;
        });
        // this.pickTicketHeaderStatus = null;
        if (this.isPickTicketCreated) {
            const pickTicketHeaderResponse = await this.pickTicketHeaderService.get(response.data.pickTicketHeaderId, { embed: "pickTicketHeaderStatus" });
            // this.pickTicketHeaderStatus = pickTicketHeaderResponse.data && pickTicketHeaderResponse.data.pickTicketHeaderStatus && pickTicketHeaderResponse.data.pickTicketHeaderStatus.name;
            runInAction(() => {
                this.isPickTicketHeaderInProgres = pickTicketHeaderResponse.data && pickTicketHeaderResponse.data.pickTicketHeaderStatus && pickTicketHeaderResponse.data.pickTicketHeaderStatus.abrv === "in-progress";
                this.isPickTicketHeaderCompleted = pickTicketHeaderResponse.data && pickTicketHeaderResponse.data.pickTicketHeaderStatus && pickTicketHeaderResponse.data.pickTicketHeaderStatus.abrv === "completed";
            });
        }

        var subTitle = <React.Fragment>
            <span className="u-mar--right--sml" style={{ fontSize: "small" }}>Shipping status: <strong>{this.facilityOrder.shippingStatus ? this.facilityOrder.shippingStatus : ' - '}</strong></span>
            {/* <span style={{ fontSize: "small" }}>|</span>
            <span className="u-mar--left--sml" style={{ fontSize: "small" }}>Pick Ticket status: <strong>{this.pickTicketHeaderStatus ? this.pickTicketHeaderStatus : ' - '}</strong>  </span> */}
        </React.Fragment>;

        this.rootStore.viewStore.setSubTitleComponent(subTitle);
    }

    async setTitle() {
        const facilityOrderService = new FacilityOrderService(
            this.rootStore.application.baasic.apiClient
        );
        const facilityOrderId =
            this.rootStore.routerStore.routerState.params.id;
        const facilityOrderResponse = await facilityOrderService.get(
            facilityOrderId,
            { embed: "Facility" }
        );
        runInAction(() => {
            this.isPartBOnly = facilityOrderResponse.data.facility && facilityOrderResponse.data.facility.partBOnly;
        });
        const facilityName =
            facilityOrderResponse.data.facility &&
            facilityOrderResponse.data.facility.name;
        const facilityOrderTemplateTitle = `${facilityName} - DOS [${toDate(facilityOrderResponse.data.dateOfService)}]`;
        this.rootStore.titleStore.setTitle(facilityName ? `FO - ${facilityName}` : 'Facility Order Templates');

        this.rootStore.viewStore.setNavigationOptions({
            title: facilityOrderTemplateTitle,
            hideColon: true,
            onPreview: this.goToFacility,
            onEdit: this.editFacility,
            onCalendar: this.goToCalendar
        });
    }

    @action.bound
    async showTaskNotes() {
        this.taskNotesModal.open({
            facilityOrderId: this.rootStore.routerStore.routerState.params.id
        });
    }

    @action.bound
    openPatientAddModal() {
        this.setTitle();
        this.patientAddModal.open({
            facilityOrderId: this.rootStore.routerStore.routerState.params.id,
            facilityId: this.facilityOrder.facilityId,
            fetchTable: () => this.queryUtility.fetch()
        });
    }

    @action.bound
    openExtraSuppliesAddModal() {
        this.setTitle();
        this.extraSuppliesAddModal.open({
            facilityOrderId: this.rootStore.routerStore.routerState.params.id
        });
    }

    @action.bound
    async goToFacility() {
        const facilityOrderService = new FacilityOrderService(
            this.rootStore.application.baasic.apiClient
        );
        const facilityOrderId = this.rootStore.routerStore.routerState.params.id;
        const facilityOrderResponse = await facilityOrderService.get(
            facilityOrderId,
            { embed: "Facility" }
        );
        window.open(`${this.rootStore.routerStore.findRoute('master.app.main.facility.preview').pattern.replace(":id", facilityOrderResponse.data.facility.id)}`);
    }

    @action.bound
    async openAdjustNextRunDates() {
        const facilityOrderId = this.rootStore.routerStore.routerState.params.id;
        window.open(`${this.rootStore.routerStore.findRoute('master.app.main.facility-order.adjust-next-run-dates').pattern.replace(":facilityOrderId", facilityOrderId)}`);
    }

    @action.bound
    async editFacility() {
        const facilityOrderService = new FacilityOrderService(
            this.rootStore.application.baasic.apiClient
        );
        const facilityOrderId = this.rootStore.routerStore.routerState.params.id;
        const facilityOrderResponse = await facilityOrderService.get(
            facilityOrderId,
            { embed: "Facility" }
        );
        window.open(`${this.rootStore.routerStore.findRoute('master.app.main.facility.edit').pattern.replace(":id", facilityOrderResponse.data.facility.id)}`);
    }

    @action.bound
    async goToCalendar() {
        const facilityOrderService = new FacilityOrderService(
            this.rootStore.application.baasic.apiClient
        );
        const facilityOrderId = this.rootStore.routerStore.routerState.params.id;
        const facilityOrderResponse = await facilityOrderService.get(
            facilityOrderId,
            { embed: "Facility" }
        );
        window.open(`${this.rootStore.routerStore.findRoute('master.app.main.schedule.calendar').pattern}?facilityId=${facilityOrderResponse.data.facility.id}`);
    }

    @action.bound
    onFindSuccess() {
        this.oldDownloadUrl = this.rootStore.userStore.user && isStjepan(this.rootStore.userStore.user.userName) && `${this.service.getOldDownloadUrl({
            ...this.queryUtility.plainFilter,
            facilityOrderId:
                this.rootStore.routerStore.routerState.params &&
                this.rootStore.routerStore.routerState.params.id,
        })}&contentDisposition=attachment&token=${this.rootStore.authStore.token.tokenUrl}&ttype=${this.rootStore.authStore.token.type}`

        this.downloadUrl = `${this.service.getDownloadUrl({
            ...this.queryUtility.plainFilter,
            facilityOrderId:
                this.rootStore.routerStore.routerState.params &&
                this.rootStore.routerStore.routerState.params.id,
        })}&contentDisposition=attachment&token=${this.rootStore.authStore.token.tokenUrl}&ttype=${this.rootStore.authStore.token.type}`

        this.downloadInventoryUrl = `${this.facilityInventoryCountDetailService.getDownloadUrl({
            ...this.queryUtility.plainFilter,
            facilityOrderId:
                this.rootStore.routerStore.routerState.params &&
                this.rootStore.routerStore.routerState.params.id,
        })}&contentDisposition=attachment&token=${this.rootStore.authStore.token.tokenUrl}&ttype=${this.rootStore.authStore.token.type}`
    }

    @action.bound
    async importFacilityOrder() {
        var response = await this.service.isReviewedFacilityOrderAsync({ facilityOrderId: this.facilityOrderId });
        this.rootStore.modalStore.showConfirm(
            response.data ? 'FACILITY_ORDER_TEMPLATE.EDIT.CONFIRM_IMPORT' : 'FACILITY_ORDER_TEMPLATE.EDIT.CONFIRM_NOT_REVIEWED',
            async () => {
                try {
                    const facilityOrderService = new FacilityOrderService(
                        this.rootStore.application.baasic.apiClient
                    );
                    await facilityOrderService.importFacilityOrder({ facilityOrderId: this.facilityOrderId });
                    this.rootStore.notificationStore.success("Facility order template imported successfully.");
                }
                catch (err) {
                    if (err.data && err.data.errors) {
                        this.rootStore.notificationStore.error(err.data.errors);
                    }
                    else {
                        this.rootStore.notificationStore.error("Error occurred while trying to import a facility order templates.");
                    }
                }
            }
        );
    }

    @action.bound
    async createInventory(countDate) {
        try {
            let facilityInventoryCountHeaderId = this.facilityOrder.facilityInventoryCountHeaderId;

            if (!this.isInventoryCreated) {
                let response = await this.actions.createFacilityInventoryCountHeader(this.facilityOrder.facilityId, countDate);
                facilityInventoryCountHeaderId = response.data.id;
                await this.actions.createFacilityInventoryCountDetails(this.facilityOrder.id, facilityInventoryCountHeaderId);
            }

            let url = this.rootStore.routerStore.findRoute('master.app.main.facility-inventory.facility-inventory-detail.list').pattern;
            url = url.replace(":facilityInventoryCountHeaderId", facilityInventoryCountHeaderId);
            window.open(`${url}`);

            await this.getFacilityOrder(this.facilityOrderId);
        }
        catch (err) {
            if (err.data && err.data.errors) {
                this.rootStore.notificationStore.error(err.data.errors);
            }
            else {
                this.rootStore.notificationStore.error("Error occurred while trying to create a inventory.");
            }
        }
    }

    @action.bound
    async convertFacilityInventoryCountDetails() {
        try {
            if (!this.allEnteralReviewed) {
                this.rootStore.modalStore.showConfirm(
                    'FACILITY_ORDER_TEMPLATE.EDIT.CONFIRM_INVENTORY_COUNT',
                    async () => {
                        await this.actions.convertFacilityInventoryCountDetails(this.facilityOrder.facilityInventoryCountHeaderId);
                        this.routes.openInventoryCalculationItem();
                    }
                );
            }
            else {
                await this.actions.convertFacilityInventoryCountDetails(this.facilityOrder.facilityInventoryCountHeaderId);
                this.routes.openInventoryCalculationItem();
            }
        }
        catch (err) {
            this.rootStore.notificationStore.error("Error occurred while trying to convert inventory items.");
        }
    }

    @action.bound
    async refreshPickTicket() {
        localStorage.setItem('refreshPickTicket', true)
        this.routes.pickTicketDetails();
    }

    @action.bound
    async createPickTicket() {
        if (!this.actions.createPickTicket)
            return;

        if (!this.allFacilityOrderTemplatesReviewed) {
            this.rootStore.notificationStore.error("Pick Ticket can't be created until all templates are reviewed.");
            return;
        }

        try {
            await this.actions.createPickTicket(this.facilityOrderId);
            await this.getFacilityOrder(this.facilityOrderId);

            this.isPickTicketCreated = true;

            this.queryUtility.fetch();

            this.rootStore.notificationStore.success("Pick ticket successfully created.");

            this.routes.pickTicketDetails();

        }
        catch (err) {
            this.rootStore.notificationStore.error(err.data ? err.data : "Error occurred while trying to create a pick ticket.");
        }
    }

    renderReferenceCell(item) {
        return (
            <td>
                <div className="type--left">
                    {
                        _.zip(
                            item.dataItem.reference,
                            item.dataItem.inactiveReason).map((value) => {
                                const isNotFoundReference = value[0].includes('not-found');
                                const referenceEl = isNotFoundReference ? value[0].split(',')[1] : value[0];
                                const inactiveReason = value[1] == "Hospital" || value[1] == "Expired" || value[1] == "Discharged" || value[1] == "Do Not Supply" || value[1] == "Discontinued";
                                const doNotSupply = value[1] == "Do Not Supply" || value[1] == "" || value[1] == null;
                                const fontStyle = doNotSupply ? "" : "italic";
                                return (
                                    isNotFoundReference ?
                                        (
                                            inactiveReason ?
                                                <div style={{ color: "darkred", fontStyle: fontStyle }} key={uuid()}>
                                                    <i title='Reference Not Found' className="u-icon u-icon--sml u-icon--warning--yellow u-mar--right--tny"></i>{referenceEl !== '' ? (referenceEl) : ''}
                                                </div>
                                                :
                                                <div key={uuid()}>
                                                    <i title='Reference Not Found' className="u-icon u-icon--sml u-icon--warning--yellow u-mar--right--tny"></i>{referenceEl !== '' ? (referenceEl) : ''}
                                                </div>
                                        )
                                        :
                                        (
                                            inactiveReason ?
                                                <div style={{ color: "darkred", fontStyle: fontStyle }} key={uuid()}>
                                                    {referenceEl}
                                                </div> :
                                                <div key={uuid()}>
                                                    {referenceEl}
                                                </div>
                                        )

                                );
                            })}
                </div>
            </td>
        );
    }

    renderTemplateIdCell(item) {
        return (
            <td>
                <div className="type--left">
                    {_.zip(
                        item.dataItem.templateId,
                        item.dataItem.ids,
                        item.dataItem.inactiveReason).map((value) => {
                            const inactiveReason = value[2] == "Hospital" || value[2] == "Expired" || value[2] == "Discharged" || value[2] == "Do Not Supply" || value[2] == "Discontinued";
                            const doNotSupply = value[2] == "Do Not Supply" || value[2] == "" || value[2] == null;
                            const fontStyle = doNotSupply ? "" : "italic";
                            return (
                                value[0] ?
                                    (
                                        inactiveReason ?
                                            <div style={{ color: "darkred", fontStyle: fontStyle }} key={uuid()}>
                                                <a target='_blank' onClick={() => this.previewModal.open({ id: value[1], templateId: value[0] })}>{value[0]}</a>
                                            </div>
                                            :
                                            <div key={uuid()}>
                                                <a target='_blank' onClick={() => this.previewModal.open({ id: value[1], templateId: value[0] })}>{value[0]}</a>
                                            </div>
                                    )
                                    :
                                    (
                                        (value[1] && value[0] != null) || inactiveReason ?
                                            <div style={{ color: "darkred", fontStyle: fontStyle }} key={uuid()}>NEW</div>
                                            :
                                            <div key={uuid()}>NEW</div>
                                    )
                            );
                        })
                    }
                </div>
            </td>
        );
    }

    renderSubCategoryCell(item) {
        return (
            <td>
                <div className="type--left">
                    {_.zip(
                        item.dataItem.subCategory,
                        item.dataItem.inactiveReason).map((value) => {
                            const inactiveReason = value[1] == "Hospital" || value[1] == "Expired" || value[1] == "Discharged" || value[1] == "Do Not Supply" || value[1] == "Discontinued";
                            const doNotSupply = value[1] == "Do Not Supply" || value[1] == "" || value[1] == null;
                            const fontStyle = doNotSupply ? "" : "italic";
                            return (
                                value[0] ?
                                    (
                                        inactiveReason ?
                                            <div style={{ color: "darkred", fontStyle: fontStyle }} key={uuid()}>
                                                {value[0]}
                                            </div>
                                            :
                                            <div key={uuid()}>
                                                {value[0]}
                                            </div>
                                    )
                                    :
                                    (
                                        inactiveReason ?
                                            <div style={{ color: "darkred", fontStyle: fontStyle }} key={uuid()}>NEW</div>
                                            :
                                            <div key={uuid()}>NEW</div>
                                    )
                            );
                        })
                    }
                </div>
            </td>
        );
    }

    renderImportDetailStatusCell(item) {
        return (
            <td>
                <div className="type--left">
                    {_.zip(
                        item.dataItem.importDetailStatus,
                        item.dataItem.errorMessage).map((value) => {
                            return (
                                value[0] == "Failed" ?
                                    <div key={uuid()} className="type--color--warning">
                                        {value[0]}
                                        <i title={value[1]} className="u-icon u-icon--sml u-icon--warning--red u-mar--left--tny"></i>
                                    </div>
                                    :
                                    <div key={uuid()}>{value[0]}</div>
                            );
                        })
                    }
                </div>
            </td>
        );
    }

    renderInactiveReasonCell(item) {
        return (
            <td>
                <div className="type--left">
                    {_.zip(
                        item.dataItem.inactiveReason).map((value) => {
                            const inactiveReason = value[0] == "Hospital" || value[0] == "Expired" || value[0] == "Discharged" || value[0] == "Do Not Supply" || value[0] == "Discontinued";
                            const doNotSupply = value[0] == "Do Not Supply" || value[0] == "" || value[0] == null;
                            const fontStyle = doNotSupply ? "" : "italic";
                            return (
                                value[0] ?
                                    (
                                        inactiveReason ?
                                            <div style={{ color: "darkred", fontStyle: fontStyle }} key={uuid()}>
                                                {value[0]}
                                            </div>
                                            :
                                            <div key={uuid()}>
                                                {value[0]}
                                            </div>
                                    )
                                    :
                                    (
                                        inactiveReason ?
                                            <div style={{ color: "darkred", fontStyle: fontStyle }} key={uuid()}>NEW</div>
                                            :
                                            <div key={uuid()}>NEW</div>
                                    )
                            );
                        })
                    }
                </div>
            </td>
        );
    }

    renderNextRunDateCell(item) {
        return (
            <td>
                <div className="type--left">
                    {_.zip(
                        item.dataItem.nextRunDate,
                        item.dataItem.notCurrent,
                        item.dataItem.inactiveReason).map((value) => {
                            const inactiveReason = value[2] == "Hospital" || value[2] == "Expired" || value[2] == "Discharged" || value[2] == "Do Not Supply" || value[2] == "Discontinued";
                            const doNotSupply = value[2] == "Do Not Supply" || value[2] == "" || value[2] == null || value[2] == "None";
                            const fontStyle = doNotSupply ? "" : "italic";
                            const color = inactiveReason === true ? "darkred" : "";
                            return (
                                value[0] ?
                                    (
                                        value[1] ?
                                            <div style={{ color: color, fontWeight: "bold" }} key={uuid()}>
                                                {value[0]}
                                            </div>
                                            :
                                            <div style={{ color: color, fontStyle: fontStyle }} key={uuid()}>
                                                {value[0]}
                                            </div>
                                    )
                                    :
                                    (
                                        value[1] ?
                                            <div style={{ fontWeight: "bold" }} key={uuid()}>NEW</div>
                                            :
                                            <div style={{ color: color, fontStyle: fontStyle }} key={uuid()}>NEW</div>
                                    )
                            );
                        })
                    }
                </div>
            </td>
        );
    }

    renderFirstNameCell(item) {
        const firstName = item.dataItem.firstName;
        const isProcessing = item.dataItem.isProcessing;
        return (
            <td>
                <div className="type--left">
                    {firstName}
                    {isProcessing && <i style={{
                        display: "inline-block",
                        marginLeft: "7px",
                        ariaLabel: "Label"
                    }} className="u-icon u-icon--sml u-icon--new-user"></i>
                    }
                </div>
            </td>
        );
    }

    renderIsReviewedCell(item, edit) {
        const props = { ...item, edit };
        return (
            <GridMultilineBooleanCell {...props} />
        );
    }

    @action.bound
    async openFacilityInventoryCountEditModal() {
        this.setTitle();
        this.facilityInventoryCountEditModal.open({
            createInventory: (countDate) => this.createInventory(countDate),
            facilityOrder: this.facilityOrder,
            title: "Add Inventory"
        });
    }
}

export default FacilityOrderTemplateListViewStore;
